export default "__VITE_ASSET__BO8Rj0se__"